import { render } from "./404.vue?vue&type=template&id=65c4a723&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=65c4a723&lang=css&scoped=true"

import exportComponent from "/var/www/test.mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c4a723"]])

export default __exports__